import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, Button, Space } from 'antd';
import { OrganizationContext } from '../../../Services/OrganizationContext';
import authService from '../../../Services/authService';
import { useParams } from "react-router";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { usePermissions } from '../../../Services/PermissionsContext';
import { hasPermission } from '../../../Services/checkPermissions';

const LeaveRequests = () => {
  const permissions = usePermissions();
  const navigate = useNavigate();
  const { organization } = useContext(OrganizationContext);
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({ search: '' });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    if (organization) {
      loadLeavesHistory(currentPage, pageSize);
    }
  }, [organization, currentPage, pageSize]);

  const handlePageChange = (page, newPageSize) => {
    setCurrentPage(page);
    setPageSize(newPageSize);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const loadLeavesHistory = (page = 1, perPage = pageSize) => {
    const token = authService.getCurrentadmin().token;
    const url = new URL(authService.getApiUrl() + 'leavehistory');

    fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        organization_id: organization,
        page,
        per_page: perPage,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (res.status === 401) {
          authService.logout();
          window.location.href = "/admin";
        } else {
          return res.json();
        }
      })
      .then((result) => {
        setData(result.data || []);
        setTotalRecords(result.total || 0);
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const token = authService.getCurrentadmin().token;

    fetch(authService.getApiUrl() + 'searchleave', {
      method: 'POST',
      body: JSON.stringify({
        search: formData.search,
        organization_id:organization,
       // user_id: authService.getCurrentadmin().UserInfo.id,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setData(result.data || []);
        setTotalRecords(result.total || 0);
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  const updateStatus = (record, status) => {
    const token = authService.getCurrentadmin().token;

    fetch(authService.getApiUrl() + 'leavehistory/' + record.id, {
      method: 'PUT',
      body: JSON.stringify({
        leave_status: status,
        //id: record.record.id,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then(() => {
        loadLeavesHistory(currentPage, pageSize);
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  const columns = [
    {
      title: "User Name",
      dataIndex: "user_name",
      render: (text) => <span>{text || '-'}</span>,
      sorter: (a, b) => (a.user_name || '').localeCompare(b.user_name || ''),
    },
    {
      title: "Description",
      dataIndex: "remarks",
      render: (text) => <span>{text}</span>,
      //sorter: (a, b) => (a.invoice_number || '').localeCompare(b.invoice_number || ''),
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => (a.date || '').localeCompare(b.date || ''),
    },

    {
      title: "Type",
      dataIndex: "status",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => parseFloat(a.date_time) - parseFloat(b.date_time),
    },
    {
      title: "status",
      dataIndex: "leave_status",
      render: (text) => <span
        className={text === "Approved" ? "status-btn-green" : "status-btn-red"}
        style={{ whiteSpace: 'nowrap', cursor: 'pointer' }}
      >
        {text}
      </span>,
      //sorter: (a, b) => parseFloat(a.leave_status) - parseFloat(b.leave_status),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => {
        const showRefundButton = record.leave_status === "Pending";

        return (
          <Space size="middle">
            {showRefundButton && (
              <>
                <span
                  className='status-btn-green'
                  style={{ whiteSpace: 'nowrap', cursor: 'pointer' }}
                  onClick={() => updateStatus(record, 'Approved')}
                >
                  Approve
                </span>
                <span
                  className='status-btn-red'
                  style={{ whiteSpace: 'nowrap', cursor: 'pointer' }}
                  onClick={() => updateStatus(record, 'Rejected')}
                >
                  Reject
                </span>
              </>
            )}
          </Space>
        );
      },
    },
  ];

  return (
    <div className='main-container'>
      <div className='container-fluid'>
        <Breadcrumb />
        <div className='category-table'>
          <div className='flex-cont add-cat'>
            <div className='heading'>
              <h3>Leaves History</h3>
            </div>
          </div>
          <div className='flex-cont just-cont-left bord-botm'>
            <div className='filter-search'>
              <input
                type='text'
                className='category-search'
                placeholder='Search by date'
                onChange={handleInputChange}
                name="search"
                id="search"
              />
              <Button type='submit' onClick={handleSubmit}>Search</Button>
            </div>
          </div>
          <div className='hospitals-table' id='hospitals_table'>
            <Table
              dataSource={data}
              columns={columns}
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: totalRecords,
                onChange: handlePageChange,
              }}
              rowKey={(record) => record.id}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveRequests;
